/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CognitoPayoutStatus {
	Paid = 'Paid',
	Pending = 'Pending',
	Sent = 'Sent',
	Canceled = 'Canceled',
	Failed = 'Failed',
}
